

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CertificateCorporateListConfig } from "./data/CertificateCorporateListConfig"
import { CertificateCorporateListdata } from "./data/CertificateCorporateList.data"
import FormCreator from "../../../components/Forms/FormCreator"
import Buttons from "../../../components/ui/button/Buttons"
import MolGrid from "../../../components/Grid/MolGrid"
import { useGetCertificateCorporateListMutation } from "../../../app/services/CorporateCertificate/corporateCertificateApi";
import { encryptAESID } from "../../../utils/Encryption";

const CertificateCorporateList = () => {
  const navigate = useNavigate()
  const molGridRef = useRef();
  const MemberApplicationRef = useRef();
  const [formData, setFormData] = useState(CertificateCorporateListdata);
  const [dataSource, setDataSource] = useState();
  const [totalRecord, setTotalRecord] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    PageNo: 1,
    PageSize: 10,
    endPage: 100,
    CompanyUENNumber: null,
    totalCount: 0,
    HaveApplicationsId: null,
    HaveCertificationsId: null,
  });
  const [getCertificateCorporateList, { isLoading: certificateListIsLoading, isSuccess: certificateListIsSuccess, data: certificateList, }] = useGetCertificateCorporateListMutation();
  const handleSearch = () => {
    const taskListFormData = MemberApplicationRef?.current?.getFormData();
    const updatedPaginationRequest = {
      pageNo: 1,
      pageSize: 10,
      endPage: 100,
      CompanyUENNumber: taskListFormData?.companyNameOrUen || null,
      HaveApplicationsId: taskListFormData?.haveapplications?.value || taskListFormData?.haveapplications,
      HaveCertificationsId: taskListFormData.haveCertifications?.value || taskListFormData?.haveCertifications,
    };
    setPaginationRequest(updatedPaginationRequest);
    getCertificateCorporateList(updatedPaginationRequest);
  };
  const handleClearClick = () => {
    const updatedFormData = { ...formData };
    updatedFormData.initialState = {
      companyNameOrUen: '',
      haveapplications: null,
      haveCertifications: null,
    };
    const request = {
      PageNo: 1,
      PageSize: 10,
      endPage: 100,
      totalCount: 0,
      CompanyUENNumber: null,
      HaveApplicationsId: null,
      HaveCertificationsId: null,
    };
    setPaginationRequest(request);
    getCertificateCorporateList(request);
    setFormData(updatedFormData);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getCertificateCorporateList(updatedPaginationRequest);
  };
  const handleActionClick = (data) => {    
    navigate(`/viewCertificateCorporateAccountPage/${encryptAESID(data?.sgbcCorporateMemberId)}`)
  }

  useEffect(() => {
    getCertificateCorporateList(paginationRequest)
  }, [])

  useEffect(() => {
    if (!certificateListIsLoading && certificateListIsSuccess && certificateList) {      
      setTotalRecord(certificateList?.totalCount);
      setDataSource(certificateList?.itemList);
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: certificateList?.totalCount || 0,
      }));
    }
  }, [certificateListIsLoading, certificateListIsSuccess, certificateList])

  const actionHandler = {
    "View": handleActionClick,
  }


  return (
    <div className="corporate-member-list member-application-task-list">
      <div className="member-list-filter row">
        <div className="row status-input">
          <FormCreator
            ref={MemberApplicationRef}
            {...formData}
          />

        </div>
        <div className="right-side-btn pr-3">
          <Buttons
            buttonText="Clear"
            buttonTypeClassName="btn btn-secondary"
            onClick={handleClearClick}
          />
          <Buttons
            buttonText="Search"
            buttonTypeClassName="success-btn"
            onClick={handleSearch}
          />

        </div>
      </div>

      <div className="member-list membership-app-list certificate-corporate-list">
        <div>
          <h4> {totalRecord} Corporate Members</h4>
        </div>
        <MolGrid
          ref={molGridRef}
          configuration={CertificateCorporateListConfig}
          dataSource={dataSource}
          allowPagination={true}
          pagination={paginationRequest}
          onPageChange={handlePageChange}
          onActionChange={actionHandler}
        />
      </div>
    </div>
  );
};

export default CertificateCorporateList;
